(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magnesium-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.aft-hero').forEach(function (section) {
    var opts = section.querySelectorAll('[data-buy-opt]');
    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        opts.forEach(function (o) {
          o.classList.remove('is-selected');
          var r = o.querySelector('.aft-hero__radio');
          if (r) r.checked = false;
        });
        opt.classList.add('is-selected');
        var radio = opt.querySelector('.aft-hero__radio');
        if (radio) radio.checked = true;
      });
    });

    var thumbs = section.querySelectorAll('[data-thumb]');
    var mainWrapper = section.querySelector('[data-main-image]');
    var mainImg = mainWrapper ? mainWrapper.querySelector('img') : null;
    if (thumbs.length && mainImg) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var url = thumb.getAttribute('data-image-url');
          if (url) {
            mainImg.src = url;
            mainImg.srcset = '';
          }
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
